export default "__VITE_ASSET__CSaZBoVN__"